// extracted by mini-css-extract-plugin
export default {"grid":"NumPad_grid__IsvcB","key":"NumPad_key__hVjv4","keyAction":"NumPad_keyAction__g4oXu NumPad_key__hVjv4"};